import { render, staticRenderFns } from "./TeacherStatusEditDialog.vue?vue&type=template&id=3ceb3782"
import script from "./TeacherStatusEditDialog.vue?vue&type=script&lang=js"
export * from "./TeacherStatusEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports